import React from 'react';
import PropTypes from 'prop-types';

const Contacts = ({ contacts: { address, phone, email } }) => (
  <section className="section contacts">
    <iframe
      title="contact-map"
      className="contacts-map"
      src="https://yandex.ru/map-widget/v1/?um=mymaps%3ASOVmtZuemwk-eUe6AYS9cMS_gdx_b7hV&amp;source=constructor"
      width="600"
      height="450"
      frameBorder="0"
      style={{ border: 0 }}
      allowFullScreen
    />
    <div className="container">
      <div className="card-info">
        <h2 className="title-2">Контакты</h2>
        <ul className="contacts-list">
          <li className="contacts-item address">{address}</li>
          <li className="contacts-item email">
            <a className="contacts-link" href={`mailto:${email}`}>
              {email}
            </a>
          </li>
          <li className="contacts-item phone">
            <a className="contacts-link" href={`tel:${phone}`}>
              {phone}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </section>
);

Contacts.propTypes = {
  contacts: PropTypes.shape({
    instagram: PropTypes.string.isRequired,
    facebook: PropTypes.string.isRequired,
    vk: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
  }).isRequired,
};

export default Contacts;
